import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import * as strings from '../helpers/strings';

const ComfirmDialog = ({ title, message, onCancel, onOK, btnCancelText, btnOKText, open}) => (
  <Dialog
    maxWidth="sm"
    open={open}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color={strings.colorPrimary}>{btnCancelText}</Button>
      <Button onClick={onOK} color={strings.colorPrimary} autoFocus>{btnOKText}</Button>
    </DialogActions>
  </Dialog>
);

export default ComfirmDialog;